import React from "react";
import { IconProps } from "./IconProps";

const Comparison: React.FC<IconProps> = ({
  size = 20,
  color = "#F7F9F9",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 17 19"
      fill="none"
      {...props}
    >
      <path
        d="M6.25 9.75L9.25 6.75M9.25 6.75L6.25 3.75M9.25 6.75L3.25 6.75"
        stroke={color}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5 11.25L13.75 11.25"
        stroke={color}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 17.3001L10.5 14.6001"
        stroke={color}
        strokeWidth="1.66"
        strokeLinecap="round"
      />
      <path
        d="M5.5 12V14.1C5.5 14.9401 5.5 15.3601 5.66349 15.681C5.8073 15.9632 6.03677 16.1927 6.31901 16.3365C6.63988 16.5 7.05992 16.5 7.9 16.5H13.6C14.4401 16.5 14.8601 16.5 15.181 16.3365C15.4632 16.1927 15.6927 15.9632 15.8365 15.681C16 15.3601 16 14.9401 16 14.1V8.4C16 7.55992 16 7.13988 15.8365 6.81901C15.6927 6.53677 15.4632 6.3073 15.181 6.16349C14.8601 6 14.4401 6 13.6 6H11.5M3.4 12H9.1C9.94008 12 10.3601 12 10.681 11.8365C10.9632 11.6927 11.1927 11.4632 11.3365 11.181C11.5 10.8601 11.5 10.4401 11.5 9.6V3.9C11.5 3.05992 11.5 2.63988 11.3365 2.31901C11.1927 2.03677 10.9632 1.8073 10.681 1.66349C10.3601 1.5 9.94008 1.5 9.1 1.5H3.4C2.55992 1.5 2.13988 1.5 1.81901 1.66349C1.53677 1.8073 1.3073 2.03677 1.16349 2.31901C1 2.63988 1 3.05992 1 3.9V9.6C1 10.4401 1 10.8601 1.16349 11.181C1.3073 11.4632 1.53677 11.6927 1.81901 11.8365C2.13988 12 2.55992 12 3.4 12Z"
        stroke={color}
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Comparison;
